import { useState } from 'react';

export const useTitleBarToggleEffect = (
  initialState: boolean
): [boolean, () => void, () => void, () => void] => {
  const [toggleValue, setToggle] = useState(initialState);

  function openTitleBar(): void {
    setToggle(true);
  }

  function closeTitleBar(): void {
    setToggle(false);
  }

  function toggleTitleBar(): void {
    setToggle(!toggleValue);
  }

  return [toggleValue, toggleTitleBar, closeTitleBar, openTitleBar];
};
